import AD from 'images/icons/flag/20x20/AD.png';
import AE from 'images/icons/flag/20x20/AE.png';
import AF from 'images/icons/flag/20x20/AF.png';
import AG from 'images/icons/flag/20x20/AG.png';
import AI from 'images/icons/flag/20x20/AI.png';
import AL from 'images/icons/flag/20x20/AL.png';
import AM from 'images/icons/flag/20x20/AM.png';
import AN from 'images/icons/flag/20x20/AN.png';
import AO from 'images/icons/flag/20x20/AO.png';
import AQ from 'images/icons/flag/20x20/AQ.png';
import AR from 'images/icons/flag/20x20/AR.png';
import AS from 'images/icons/flag/20x20/AS.png';
import AT from 'images/icons/flag/20x20/AT.png';
import AU from 'images/icons/flag/20x20/AU.png';
import AW from 'images/icons/flag/20x20/AW.png';
import AZ from 'images/icons/flag/20x20/AZ.png';
import BA from 'images/icons/flag/20x20/BA.png';
import BB from 'images/icons/flag/20x20/BB.png';
import BD from 'images/icons/flag/20x20/BD.png';
import BE from 'images/icons/flag/20x20/BE.png';
import BF from 'images/icons/flag/20x20/BF.png';
import BG from 'images/icons/flag/20x20/BG.png';
import BH from 'images/icons/flag/20x20/BH.png';
import BI from 'images/icons/flag/20x20/BI.png';
import BJ from 'images/icons/flag/20x20/BJ.png';
import BL from 'images/icons/flag/20x20/BL.png';
import BM from 'images/icons/flag/20x20/BM.png';
import BN from 'images/icons/flag/20x20/BN.png';
import BO from 'images/icons/flag/20x20/BO.png';
import BQ from 'images/icons/flag/20x20/BQ.png';
import BR from 'images/icons/flag/20x20/BR.png';
import BS from 'images/icons/flag/20x20/BS.png';
import BT from 'images/icons/flag/20x20/BT.png';
import BW from 'images/icons/flag/20x20/BW.png';
import BY from 'images/icons/flag/20x20/BY.png';
import BZ from 'images/icons/flag/20x20/BZ.png';
import CA from 'images/icons/flag/20x20/CA.png';
import CC from 'images/icons/flag/20x20/CC.png';
import CD from 'images/icons/flag/20x20/CD.png';
import CF from 'images/icons/flag/20x20/CF.png';
import CG from 'images/icons/flag/20x20/CG.png';
import CH from 'images/icons/flag/20x20/CH.png';
import CI from 'images/icons/flag/20x20/CI.png';
import CK from 'images/icons/flag/20x20/CK.png';
import CL from 'images/icons/flag/20x20/CL.png';
import CM from 'images/icons/flag/20x20/CM.png';
import CN from 'images/icons/flag/20x20/CN.png';
import CO from 'images/icons/flag/20x20/CO.png';
import CR from 'images/icons/flag/20x20/CR.png';
import CU from 'images/icons/flag/20x20/CU.png';
import CV from 'images/icons/flag/20x20/CV.png';
import CW from 'images/icons/flag/20x20/CW.png';
import CX from 'images/icons/flag/20x20/CX.png';
import CY from 'images/icons/flag/20x20/CY.png';
import CZ from 'images/icons/flag/20x20/CZ.png';
import DE from 'images/icons/flag/20x20/DE.png';
import DJ from 'images/icons/flag/20x20/DJ.png';
import DK from 'images/icons/flag/20x20/DK.png';
import DO from 'images/icons/flag/20x20/DO.png';
import DZ from 'images/icons/flag/20x20/DZ.png';
import EC from 'images/icons/flag/20x20/EC.png';
import EE from 'images/icons/flag/20x20/EE.png';
import EG from 'images/icons/flag/20x20/EG.png';
import ER from 'images/icons/flag/20x20/ER.png';
import ES from 'images/icons/flag/20x20/ES.png';
import ET from 'images/icons/flag/20x20/ET.png';
import EU from 'images/icons/flag/20x20/EU.png';
import FI from 'images/icons/flag/20x20/FI.png';
import FJ from 'images/icons/flag/20x20/FJ.png';
import FK from 'images/icons/flag/20x20/FK.png';
import FM from 'images/icons/flag/20x20/FM.png';
import FO from 'images/icons/flag/20x20/FO.png';
import FR from 'images/icons/flag/20x20/FR.png';
import GA from 'images/icons/flag/20x20/GA.png';
import GB from 'images/icons/flag/20x20/GB.png';
import GD from 'images/icons/flag/20x20/GD.png';
import GE from 'images/icons/flag/20x20/GE.png';
import GG from 'images/icons/flag/20x20/GG.png';
import GH from 'images/icons/flag/20x20/GH.png';
import GI from 'images/icons/flag/20x20/GI.png';
import GL from 'images/icons/flag/20x20/GL.png';
import GM from 'images/icons/flag/20x20/GM.png';
import GN from 'images/icons/flag/20x20/GN.png';
import GP from 'images/icons/flag/20x20/GP.png';
import GQ from 'images/icons/flag/20x20/GQ.png';
import GR from 'images/icons/flag/20x20/GR.png';
import GS from 'images/icons/flag/20x20/GS.png';
import GT from 'images/icons/flag/20x20/GT.png';
import GU from 'images/icons/flag/20x20/GU.png';
import GW from 'images/icons/flag/20x20/GW.png';
import GY from 'images/icons/flag/20x20/GY.png';
import HK from 'images/icons/flag/20x20/HK.png';
import HN from 'images/icons/flag/20x20/HN.png';
import HR from 'images/icons/flag/20x20/HR.png';
import HT from 'images/icons/flag/20x20/HT.png';
import HU from 'images/icons/flag/20x20/HU.png';
import ID from 'images/icons/flag/20x20/ID.png';
import IE from 'images/icons/flag/20x20/IE.png';
import IL from 'images/icons/flag/20x20/IL.png';
import IM from 'images/icons/flag/20x20/IM.png';
import IN from 'images/icons/flag/20x20/IN.png';
import IO from 'images/icons/flag/20x20/IO.png';
import IQ from 'images/icons/flag/20x20/IQ.png';
import IR from 'images/icons/flag/20x20/IR.png';
import IS from 'images/icons/flag/20x20/IS.png';
import IT from 'images/icons/flag/20x20/IT.png';
import JE from 'images/icons/flag/20x20/JE.png';
import JM from 'images/icons/flag/20x20/JM.png';
import JO from 'images/icons/flag/20x20/JO.png';
import JP from 'images/icons/flag/20x20/JP.png';
import KE from 'images/icons/flag/20x20/KE.png';
import KG from 'images/icons/flag/20x20/KG.png';
import KH from 'images/icons/flag/20x20/KH.png';
import KI from 'images/icons/flag/20x20/KI.png';
import KM from 'images/icons/flag/20x20/KM.png';
import KN from 'images/icons/flag/20x20/KN.png';
import KP from 'images/icons/flag/20x20/KP.png';
import KR from 'images/icons/flag/20x20/KR.png';
import KW from 'images/icons/flag/20x20/KW.png';
import KY from 'images/icons/flag/20x20/KY.png';
import KZ from 'images/icons/flag/20x20/KZ.png';
import LA from 'images/icons/flag/20x20/LA.png';
import LB from 'images/icons/flag/20x20/LB.png';
import LC from 'images/icons/flag/20x20/LC.png';
import LI from 'images/icons/flag/20x20/LI.png';
import LK from 'images/icons/flag/20x20/LK.png';
import LR from 'images/icons/flag/20x20/LR.png';
import LS from 'images/icons/flag/20x20/LS.png';
import LT from 'images/icons/flag/20x20/LT.png';
import LU from 'images/icons/flag/20x20/LU.png';
import LV from 'images/icons/flag/20x20/LV.png';
import LY from 'images/icons/flag/20x20/LY.png';
import MA from 'images/icons/flag/20x20/MA.png';
import MC from 'images/icons/flag/20x20/MC.png';
import MD from 'images/icons/flag/20x20/MD.png';
import ME from 'images/icons/flag/20x20/ME.png';
import MF from 'images/icons/flag/20x20/MF.png';
import MG from 'images/icons/flag/20x20/MG.png';
import MH from 'images/icons/flag/20x20/MH.png';
import MK from 'images/icons/flag/20x20/MK.png';
import ML from 'images/icons/flag/20x20/ML.png';
import MM from 'images/icons/flag/20x20/MM.png';
import MN from 'images/icons/flag/20x20/MN.png';
import MO from 'images/icons/flag/20x20/MO.png';
import MP from 'images/icons/flag/20x20/MP.png';
import MQ from 'images/icons/flag/20x20/MQ.png';
import MR from 'images/icons/flag/20x20/MR.png';
import MS from 'images/icons/flag/20x20/MS.png';
import MT from 'images/icons/flag/20x20/MT.png';
import MU from 'images/icons/flag/20x20/MU.png';
import MV from 'images/icons/flag/20x20/MV.png';
import MW from 'images/icons/flag/20x20/MW.png';
import MX from 'images/icons/flag/20x20/MX.png';
import MY from 'images/icons/flag/20x20/MY.png';
import MZ from 'images/icons/flag/20x20/MZ.png';
import NA from 'images/icons/flag/20x20/NA.png';
import NC from 'images/icons/flag/20x20/NC.png';
import NE from 'images/icons/flag/20x20/NE.png';
import NF from 'images/icons/flag/20x20/NF.png';
import NG from 'images/icons/flag/20x20/NG.png';
import NI from 'images/icons/flag/20x20/NI.png';
import NL from 'images/icons/flag/20x20/NL.png';
import NO from 'images/icons/flag/20x20/NO.png';
import NP from 'images/icons/flag/20x20/NP.png';
import NR from 'images/icons/flag/20x20/NR.png';
import NU from 'images/icons/flag/20x20/NU.png';
import NZ from 'images/icons/flag/20x20/NZ.png';
import OM from 'images/icons/flag/20x20/OM.png';
import PA from 'images/icons/flag/20x20/PA.png';
import PE from 'images/icons/flag/20x20/PE.png';
import PF from 'images/icons/flag/20x20/PF.png';
import PG from 'images/icons/flag/20x20/PG.png';
import PH from 'images/icons/flag/20x20/PH.png';
import PK from 'images/icons/flag/20x20/PK.png';
import PL from 'images/icons/flag/20x20/PL.png';
import PM from 'images/icons/flag/20x20/PM.png';
import PN from 'images/icons/flag/20x20/PN.png';
import PR from 'images/icons/flag/20x20/PR.png';
import PS from 'images/icons/flag/20x20/PS.png';
import PT from 'images/icons/flag/20x20/PT.png';
import PW from 'images/icons/flag/20x20/PW.png';
import PY from 'images/icons/flag/20x20/PY.png';
import QA from 'images/icons/flag/20x20/QA.png';
import RO from 'images/icons/flag/20x20/RO.png';
import RS from 'images/icons/flag/20x20/RS.png';
import RU from 'images/icons/flag/20x20/RU.png';
import RW from 'images/icons/flag/20x20/RW.png';
import SA from 'images/icons/flag/20x20/SA.png';
import SB from 'images/icons/flag/20x20/SB.png';
import SC from 'images/icons/flag/20x20/SC.png';
import SD from 'images/icons/flag/20x20/SD.png';
import SE from 'images/icons/flag/20x20/SE.png';
import SG from 'images/icons/flag/20x20/SG.png';
import SH from 'images/icons/flag/20x20/SH.png';
import SI from 'images/icons/flag/20x20/SI.png';
import SJ from 'images/icons/flag/20x20/SJ.png';
import SK from 'images/icons/flag/20x20/SK.png';
import SL from 'images/icons/flag/20x20/SL.png';
import SM from 'images/icons/flag/20x20/SM.png';
import SN from 'images/icons/flag/20x20/SN.png';
import SO from 'images/icons/flag/20x20/SO.png';
import SR from 'images/icons/flag/20x20/SR.png';
import SS from 'images/icons/flag/20x20/SS.png';
import ST from 'images/icons/flag/20x20/ST.png';
import SV from 'images/icons/flag/20x20/SV.png';
import SY from 'images/icons/flag/20x20/SY.png';
import SZ from 'images/icons/flag/20x20/SZ.png';
import TC from 'images/icons/flag/20x20/TC.png';
import TD from 'images/icons/flag/20x20/TD.png';
import TG from 'images/icons/flag/20x20/TG.png';
import TH from 'images/icons/flag/20x20/TH.png';
import TJ from 'images/icons/flag/20x20/TJ.png';
import TK from 'images/icons/flag/20x20/TK.png';
import TL from 'images/icons/flag/20x20/TL.png';
import TM from 'images/icons/flag/20x20/TM.png';
import TN from 'images/icons/flag/20x20/TN.png';
import TO from 'images/icons/flag/20x20/TO.png';
import TP from 'images/icons/flag/20x20/TP.png';
import TR from 'images/icons/flag/20x20/TR.png';
import TT from 'images/icons/flag/20x20/TT.png';
import TV from 'images/icons/flag/20x20/TV.png';
import TW from 'images/icons/flag/20x20/TW.png';
import TZ from 'images/icons/flag/20x20/TZ.png';
import UA from 'images/icons/flag/20x20/UA.png';
import UG from 'images/icons/flag/20x20/UG.png';
import US from 'images/icons/flag/20x20/US.png';
import UY from 'images/icons/flag/20x20/UY.png';
import UZ from 'images/icons/flag/20x20/UZ.png';
import VA from 'images/icons/flag/20x20/VA.png';
import VC from 'images/icons/flag/20x20/VC.png';
import VE from 'images/icons/flag/20x20/VE.png';
import VG from 'images/icons/flag/20x20/VG.png';
import VI from 'images/icons/flag/20x20/VI.png';
import VN from 'images/icons/flag/20x20/VN.png';
import VU from 'images/icons/flag/20x20/VU.png';
import WF from 'images/icons/flag/20x20/WF.png';
import WS from 'images/icons/flag/20x20/WS.png';
import XK from 'images/icons/flag/20x20/XK.png';
import YE from 'images/icons/flag/20x20/YE.png';
import YT from 'images/icons/flag/20x20/YT.png';
import ZA from 'images/icons/flag/20x20/ZA.png';
import ZM from 'images/icons/flag/20x20/ZM.png';
import ZW from 'images/icons/flag/20x20/ZW.png';

export default {
	AD,
	AE,
	AF,
	AG,
	AI,
	AL,
	AM,
	AN,
	AO,
	AQ,
	AR,
	AS,
	AT,
	AU,
	AW,
	AZ,
	BA,
	BB,
	BD,
	BE,
	BF,
	BG,
	BH,
	BI,
	BJ,
	BL,
	BM,
	BN,
	BO,
	BQ,
	BR,
	BS,
	BT,
	BW,
	BY,
	BZ,
	CA,
	CC,
	CD,
	CF,
	CG,
	CH,
	CI,
	CK,
	CL,
	CM,
	CN,
	CO,
	CR,
	CU,
	CV,
	CW,
	CX,
	CY,
	CZ,
	DE,
	DJ,
	DK,
	DO,
	DZ,
	EC,
	EE,
	EG,
	ER,
	ES,
	ET,
	EU,
	FI,
	FJ,
	FK,
	FM,
	FO,
	FR,
	GA,
	GB,
	UK: GB,
	GD,
	GE,
	GG,
	GH,
	GI,
	GL,
	GM,
	GN,
	GP,
	GQ,
	GR,
	GS,
	GT,
	GU,
	GW,
	GY,
	HK,
	HN,
	HR,
	HT,
	HU,
	ID,
	IE,
	IL,
	IM,
	IN,
	IO,
	IQ,
	IR,
	IS,
	IT,
	JE,
	JM,
	JO,
	JP,
	KE,
	KG,
	KH,
	KI,
	KM,
	KN,
	KP,
	KR,
	KW,
	KY,
	KZ,
	LA,
	LB,
	LC,
	LI,
	LK,
	LR,
	LS,
	LT,
	LU,
	LV,
	LY,
	MA,
	MC,
	MD,
	ME,
	MF,
	MG,
	MH,
	MK,
	ML,
	MM,
	MN,
	MO,
	MP,
	MQ,
	MR,
	MS,
	MT,
	MU,
	MV,
	MW,
	MX,
	MY,
	MZ,
	NA,
	NC,
	NE,
	NF,
	NG,
	NI,
	NL,
	NO,
	NP,
	NR,
	NU,
	NZ,
	OM,
	PA,
	PE,
	PF,
	PG,
	PH,
	PK,
	PL,
	PM,
	PN,
	PR,
	PS,
	PT,
	PW,
	PY,
	QA,
	RO,
	RS,
	RU,
	RW,
	SA,
	SB,
	SC,
	SD,
	SE,
	SG,
	SH,
	SI,
	SJ,
	SK,
	SL,
	SM,
	SN,
	SO,
	SR,
	SS,
	ST,
	SV,
	SY,
	SZ,
	TC,
	TD,
	TG,
	TH,
	TJ,
	TK,
	TL,
	TM,
	TN,
	TO,
	TP,
	TR,
	TT,
	TV,
	TW,
	TZ,
	UA,
	UG,
	US,
	UY,
	UZ,
	VA,
	VC,
	VE,
	VG,
	VI,
	VN,
	VU,
	WF,
	WS,
	XK,
	YE,
	YT,
	ZA,
	ZM,
	ZW,
};
